/* unplugin-vue-components disabled */import script from "./TravelSetMeal.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelSetMeal.vue?vue&type=script&setup=true&lang=js"

import "./TravelSetMeal.vue?vue&type=style&index=0&id=75e976a7&scoped=true&lang=css"
import "./TravelSetMeal.vue?vue&type=style&index=1&id=75e976a7&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e976a7"]])

export default __exports__